module.exports = __webpack_public_path__ + "img/icon-qizhi-click.7f87a9e5.svg";